// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IIF6WPGFdxuksDYMe7Iw .c5qhmW8F5A91iNpjY0Y9{width:80%;padding:10px 5px}", "",{"version":3,"sources":["webpack://./src/features/chats/fixed-input/fixed-input.module.scss"],"names":[],"mappings":"AACE,4CACE,SAAA,CACA,gBAAA","sourcesContent":[".container {\n  .input {\n    width: 80%;\n    padding: 10px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "IIF6WPGFdxuksDYMe7Iw",
	"input": "c5qhmW8F5A91iNpjY0Y9"
};
export default ___CSS_LOADER_EXPORT___;
